import http from './http.service';

class ClaimService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/participantsClaims";
    }

    eventPermission(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/canEdit/${id}`);
    };

    getForUser(id) {
        if (!id) {
            throw new Error('User id is required');
        }

        return this.$http.get(`${this.baseUrl}/${id}/claims`);
    }

    userClaims() {
        return this.$http.get(`${this.baseUrl}/userClaims`);
    };
}

export default new ClaimService();
